import React from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@app/hooks/useLanguage';
import { Button } from 'antd';
import { getSettingId } from '@app/services/localStorage.service';
import { notificationController } from '@app/controllers/notificationController';
import { Form } from 'antd';
import { editSetting, getSetting } from '@app/api/settings.api';
import {
  setDayColorError,
  setDayColorGood,
  setDayColorWarn,
  setSettingId,
  getDayColorError,
  getDayColorGood,
  getDayColorWarn,
} from '@app/services/localStorage.service';
//import {ColorPicker} from 'rc-color-picker';
//import "rc-color-picker/assets/index.css";
import InputColor from 'react-input-color';

export const DashboardDayColorPicker: React.FC = () => {
  const { t } = useTranslation();

  let dayColorGood = getDayColorGood(window.location.pathname.split('/')[1]);
  let dayColorWarn = getDayColorWarn(window.location.pathname.split('/')[1]);
  let dayColorError = getDayColorError(window.location.pathname.split('/')[1]);

  const changeColorGood = async (values: any) => {
    console.log('changeColorGood ', values);
    dayColorGood = values.hex;
  };

  const changeColorWarn = async (values: any) => {
    console.log('changeColorWarn ', values);
    dayColorWarn = values.hex;
  };

  const changeColorError = async (values: any) => {
    console.log('changeColorError ', values);
    dayColorError = values.hex;
  };

  const saveSetting = async (values: any) => {
    try {
      const req = {
        id: getSettingId(window.location.pathname.split('/')[1]),
        dayColorGood: dayColorGood,
        dayColorWarn: dayColorWarn,
        dayColorError: dayColorError,
      };

      console.log('setting to update ', req);
      editSetting(req).then((res) => {
        notificationController.success({ message: t('common.success') });
        getSetting().then((respSetting) => {
          if (respSetting.data) {
            const data = respSetting.data;
            setSettingId(data.id, window.location.pathname.split('/')[1]);
            setDayColorGood(data.dayColorGood, window.location.pathname.split('/')[1]);
            setDayColorWarn(data.dayColorWarn, window.location.pathname.split('/')[1]);
            setDayColorError(data.dayColorError, window.location.pathname.split('/')[1]);
          }
        });
      });
    } catch (errInfo) {
      console.log('Failed:', errInfo);
    }
  };

  return (
    <Form name="changeDayColorForm" onFinish={saveSetting}>
      <Radio.Group>
        {/* <Space direction="vertical"> */}

        <Form.Item>
          <InputColor
            initialValue={dayColorGood}
            onChange={changeColorGood}
            placement="left"
            style={{ marginBottom: '-5px', marginRight: '20px' }}
          />

          <label>{t('common.goodDay')}</label>
        </Form.Item>

        <Form.Item name="dayColorWarn">
          <InputColor
            initialValue={dayColorWarn}
            onChange={changeColorWarn}
            placement="left"
            style={{ marginBottom: '-5px', marginRight: '20px' }}
          />
          <label htmlFor="">{t('common.warnDay')}</label>
        </Form.Item>

        <Form.Item name="dayColorError">
          <InputColor
            initialValue={dayColorError}
            onChange={changeColorError}
            placement="left"
            style={{ marginBottom: '-5px', marginRight: '20px' }}
          />
          <label htmlFor="">{t('common.criticalDay')}</label>
        </Form.Item>

        <Form.Item>
          <Button type="primary" style={{ marginTop: 14 }} htmlType="submit">
            {t('common.submit')}
          </Button>
        </Form.Item>
        {/* </Space> */}
      </Radio.Group>
    </Form>
  );
};
